import {
  ProductConfiguration,
  ProductOptions,
} from '@storefront/types/Product';
import { getSelectedOptionsPrice } from '@storefront/utils/priceHandler';
import currency from 'currency.js';

import { BundleProductWithLowestPrice } from '../product-configuration/product-configuration.utils';

type SKUOptions = Record<string, string[]>;

export const calculatePricesAndSetOptions = (
  multipleProduct: BundleProductWithLowestPrice[],
  selections: ProductConfiguration,
  activeProduct: string
) => {
  const skuOptions: SKUOptions = {};
  let totalPrice = currency(0);
  let totalPricePerMonth = currency(0);
  let totalSubscriptionPricePerMonth = currency(0);
  let totalDevicePricePerMonth = currency(0);
  let totalDevice = currency(0);

  multipleProduct?.forEach((product) => {
    if (activeProduct === product.sku) {
      const {
        grandTotal,
        pricePerMonth,
        totalDevicePrice,
        subscriptionPricePerMonth,
        devicePricePerMonth,
        options,
      } = getSelectedOptionsPrice(
        product,
        (selections?.[product.sku] ?? {}) as ProductOptions
      );
      skuOptions[product.sku] = options;
      totalDevice = totalDevice.add(totalDevicePrice);
      totalPrice = totalPrice.add(grandTotal);
      totalPricePerMonth = totalPricePerMonth.add(pricePerMonth);
      totalSubscriptionPricePerMonth = totalSubscriptionPricePerMonth.add(
        subscriptionPricePerMonth
      );
      totalDevicePricePerMonth =
        totalDevicePricePerMonth.add(devicePricePerMonth);
    }
  });

  return {
    prices: {
      totalPrice: totalPrice.value,
      totalPricePerMonth: totalPricePerMonth.value,
      totalSubscriptionPricePerMonth: totalSubscriptionPricePerMonth.value,
      totalDevicePricePerMonth: totalDevicePricePerMonth.value,
      totalDevice: totalDevice.value,
    },
    options: skuOptions,
  };
};
